<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Impresión de habladores por fecha y tienda.</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-6">
              <label>Fecha</label>
              <input v-model="current.fecha" class="form-control" type="date" />
            </div>
            <div class="col-6">
              <TiendaSelectComponent :current="current" />
            </div>
          </div>
          <div v-if="current.fecha && current.tienda" class="modal-footer">
            <button
              class="btn btn-success col-12"
              ref="cerrarModal"
              type="button"
              @click="GenerarReporte(current)"
            >
              Generar Reporte
            </button>
          </div>
        </div>
      </div>
      <div class="element-box">
        <h5 class="form-header">
          Impresión de todos los habladores por tienda y subcategoría.
        </h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-6">
              <TiendaSelectComponent :current="current2" />
            </div>
            <div class="col-6">
              <SubCategoriaSelectComponent :current="current2" />
            </div>
          </div>
          <div v-if="current2.tienda" class="modal-footer">
            <button
              class="btn btn-success col-12"
              ref="cerrarModal"
              type="button"
              @click="GenerarReporteXTienda(current)"
            >
              Generar Reporte
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import ProductosService from "@/services/catalogos/ProductosService";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import SubCategoriaSelectComponent from "@/components/commons/SubCategoriaSelectComponent ";
import Notifications from "@/notifications/notifications";
import DynamicService from "../../../services/commons/DynamicService";

export default {
  components: {
    PaginationComponent,
    TiendaSelectComponent,
    SubCategoriaSelectComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      current: {
        tienda: "",
        fecha: "",
      },
      lista_precio: "",
      current2: {
        tienda: "",
      },
      currentPage: 1,
      searchtext: "",
      filter_activo: "",
      data: [],
    };
  },
  mounted() {
    this.refreshData();
    let params = new URLSearchParams(location.search);
    var tienda = params.get("tienda");
    this.current.tienda = tienda;
  },
  methods: {
    GenerarReporte(current) {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      if (!this.current.tienda) {
        Notifications.alert.error(
          "Generar Barras",
          "El campo de tienda no puede ser nulo"
        );
        return;
      }
      window.open(
        `${baseApiUrl}/cat/reporte/?&report_name=catalogos/HabladoresHoyPorTienda.jrxml&fecha=${current.fecha}&tienda=${this.current.tienda}`
      );
      this.current.tienda = "";
      this.current.fecha = "";
    },
    GenerarReporteXTienda() {
      let self = this;
      if (!this.current2.tienda) {
        Notifications.alert.error(
          "Generar Barras",
          "El campo de tienda no puede ser nulo"
        );
        return;
      }
      self.refreshListaPrecio();
    },
    refreshListaPrecio() {
      DynamicService.fetch("cat", "tiendas", {
        codigo: this.current2.tienda,
      }).then((response) => {
        this.lista_precio = response.data.results[0].lista_precio;
        if (!this.lista_precio) {
          Notifications.alert.error(
            "Generar Barras",
            "Esta tienda no tiene asignada ninguna lista de precio"
          );
          return;
        }
        this.ImprimirReporteXTienda();
      });
    },
    ImprimirReporteXTienda() {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      let url = `tienda=${self.current2.tienda}&lista_precio=${self.lista_precio}`;
      if (this.current2.subcategoria) {
        url = url + `&subcategoria=${this.current2.subcategoria.codigo}`;
      }
      window.open(
        `${baseApiUrl}/cat/reporte/?&report_name=catalogos/HabladoresXtiendaXsubcategoria.jrxml&` +
          url
      );
      self.cleanFilters();
    },
    cleanFilters() {
      let self = this;
      self.current2.tienda = "";
      self.lista_precio = "";
      self.current2.subcategoria = "";
    },
    refreshPrecios(current) {
      let self = this;
      ProductosService.getById(current.sku).then((response) => {
        self.current = response.data;
      });
      self.showModalAddPrecios();
    },

    rowClick(current) {
      let self = this;
      self.$router.push({
        name: "cat-productos-editar",
        params: { sku: current.sku },
      });
    },
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        "filter[search]": this.searchtext,
      });
    },
    filterData() {
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        activo: this.filter_activo,
      });
    },
    filterDataSubmit(e) {
      this.filterData();
      e.preventDefault();
    },
    clearFilterData() {
      this.searchtext = "";
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
      });
    },
    hide: function () {
      this.$data.destroy();
    },
    onRefreshData() {},
    refreshData(params) {
      let self = this;
      ProductosService.fetch(params).then((res) => {
        self.data = res.data;
      });
    },
    showModalAddPrecios() {
      let self = this;
      $("#modalAddPrecios").modal();
    },
  },
};
</script>